import React, { useEffect, useState } from 'react';
import { Background, Parallax } from 'react-parallax';
import CaretakersServices from '../../../services/caretakers-services';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import Toast from '../../../shared/components/atoms/toast/toast';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import TransversalServices from '../../../shared/services/transversal-services';
import { localStorage } from '../../../shared/utils/storage';
import CtaReturn from '../../atoms/cta-return/cta-return';
import SectionBannerHeader from '../../molecules/section-banner-header/section-banner-header';
import SectionLearnFantasticHour from '../../molecules/section-learn-fantastic-hour/section-learn-fantastic-hour';
import SectionMeetModules from '../../molecules/section-meet-modules/section-meet-modules';
import SectionPromotionalBanner from '../../molecules/section-promotional-banner/section-promotional-banner';
import SectionSingleModuleIntroduction from '../../molecules/section-single-module-introduction/section-single-module-introduction';
import './single-module-content.scss';

const SingleModuleContent = ({ contentInfo }) => {

    const { homeLink } = useHomeLinkMode();

    const [videoModal, setVideoModal] = useState(null);
    const [activeModal, setActiveModal] = useState(null);
    const [userData, setUserData] = useState(null);
    const [moduleState, setModuleState] = useState(null)
    const [toast, setToast] = useState(false)
    const [modulesCompleted, setModulesCompleted] = useState(false);
    const [isFinishModule, setIsFinishModule] = useState(false);

    useEffect(() => {
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        if (tokenInfo) {
            let config = {
                headers: {
                    Authorization: tokenInfo.idToken,
                },
            }

            TransversalServices.getInfoUser(config).then(
                response => {
                    if (response.status === 200) {
                        setUserData(response.data);
                    } else {
                        setUserData(null);
                    }
                }
            ).catch(error => {
                console.error(error)
            })
        } else {
            setUserData(null);
        }
    }, []);

    useEffect(() => {
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        let courseId = parseInt(contentInfo.courseId[0])
        let moduleNumber = parseInt(contentInfo.numeroDelModulo[0])

        CaretakersServices.getModuleState({ courseId, moduleNumber }).then(res => {
            if (res?.status === 200 && res?.data) {
                if (tokenInfo) {
                    let config = {
                        headers: {
                            Authorization: tokenInfo.idToken,
                        },
                    }
                    const payload = "?courseId=" + courseId + "&moduleNumber=" + moduleNumber
    
                    CaretakersServices.validateModuleState(payload, config).then(
                        response => {
                            if (response.status === 200) {
                                setModuleState(response.data);
                            } else {
                                setModuleState(false);
                            }
                        }
                    ).catch(error => {
                        console.error(error)
                    })
    
                    const payload2 = "?courseId=" + parseInt(contentInfo.courseId[0])
    
                    CaretakersServices.courseCompletion(payload2, config).then(
                        response => {
                            if (response.status === 200) {
                                setModulesCompleted(response.data)
                            } else {
                                setModulesCompleted(false);
                            }
                        }
                    ).catch(error => {
                        console.error(error)
                    })   
                }
            } else {
                setIsFinishModule(true)
            }
        })
    }, []);

    return (
        <div className="f-o-single-module-content">
            <Parallax
                className="f-o-single-module-content__parallax"
                strength={-1200}>
                <Background className="custom-bg">
                </Background>
            </Parallax>
            <Breadcrumb />
            {videoModal &&
                <>{videoModal}</>
            }
            {activeModal &&
                <>{activeModal}</>
            }
            <CtaReturn textReturn={"Volver a Módulos"} redirect={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/modulos/")} />
            <SectionBannerHeader contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "BannerModulos")[0]} />
            <SectionSingleModuleIntroduction contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido12")[0]}
                modalData={contentInfo.modalCursoCuidadores} setActiveModal={setActiveModal} userData={userData} moduleState={moduleState} setToast={setToast} modulesCompleted={modulesCompleted}
                moduleIdentifiers={{ cmsId: contentInfo.codigoDelPremio, courseId: parseInt(contentInfo.courseId[0]), moduleNumber: parseInt(contentInfo.numeroDelModulo[0]) }} 
                isFinishModule={isFinishModule}
                isBlocked={!contentInfo.habilitadoRedimir}
            />
            <SectionMeetModules contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido7")[0]} />
            <SectionLearnFantasticHour contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido10")[0]} setVideoModal={setVideoModal} />
            <SectionPromotionalBanner contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido5")[0]} />
            <Toast
                message={toast.messageToast ? toast.messageToast : null}
                check={toast.checkToast ? toast.checkToast : null}
                activeToast={toast}
                setActiveToast={setToast}
            />
        </div>
    )
}

export default SingleModuleContent
